import React from 'react';
import {useGlobals} from '../../providers/globalPropsProvider';
import {SPECS} from '../../specs';
import {ConditionalRender} from '../ConditionalRender/ConditionalRender';
import {Ribbon, RibbonDataHook} from './Ribbon';
import s from './ProductRibbons.scss';

export enum ProductRibbonsDataHook {
  OnImageContainer = 'product-ribbons-on-image-container',
  OnImageGroup = 'product-ribbons-on-image-group',
  OnProductInfoContainer = 'product-ribbons-on-product-info-container',
}

const useProductRibbons = () => {
  const {product, useExperiments} = useGlobals();
  const isEnabled = useExperiments.enabled(SPECS.ShowMultiRibbonsInProductPage);
  return {
    isEnabled,
    ribbon: product.ribbon,
    additionalRibbons: isEnabled ? ((product as any).additionalRibbons as string[]) ?? [] : [],
  };
};

export const ProductRibbonsOnImage: React.FC = () => {
  const {isEnabled, ribbon, additionalRibbons} = useProductRibbons();
  if (!isEnabled) {
    return null;
  }

  if (!ribbon && additionalRibbons.length === 0) {
    return null;
  }

  if (additionalRibbons.length > 0) {
    return (
      <ConditionalRender
        by="shouldShowAnyRibbonOnImage"
        dataHook={ProductRibbonsDataHook.OnImageContainer}
        className={s.ribbonOverlayOnImage}>
        <div className={s.ribbonsGroupOnImage} data-hook={ProductRibbonsDataHook.OnImageGroup}>
          {ribbon && (
            <ConditionalRender by="shouldShowRibbonOnImage" className={s.ribbonWrapper}>
              <Ribbon text={ribbon} dataHook={RibbonDataHook.Primary} />
            </ConditionalRender>
          )}
          {additionalRibbons.map((additionalRibbon, i) => (
            <ConditionalRender key={i} by="shouldShowAdditionalRibbonsOnImage" className={s.ribbonWrapper}>
              <Ribbon text={additionalRibbon} dataHook={RibbonDataHook.Additional} />
            </ConditionalRender>
          ))}
        </div>
      </ConditionalRender>
    );
  }

  return (
    ribbon && (
      <ConditionalRender
        by="shouldShowRibbonOnImage"
        dataHook={ProductRibbonsDataHook.OnImageContainer}
        className={s.ribbonOverlayOnImage}>
        <div className={s.ribbonsGroupOnImage} data-hook={ProductRibbonsDataHook.OnImageGroup}>
          <Ribbon text={ribbon} dataHook={RibbonDataHook.Primary} />
        </div>
      </ConditionalRender>
    )
  );
};

export const ProductRibbonsOnProductInfo: React.FC = () => {
  const {isEnabled, ribbon, additionalRibbons} = useProductRibbons();
  if (!isEnabled) {
    return null;
  }

  if (!ribbon && additionalRibbons.length === 0) {
    return null;
  }

  if (additionalRibbons.length > 0) {
    return (
      <ConditionalRender by="shouldShowAnyRibbonOnProductInfo" dataHook={ProductRibbonsDataHook.OnProductInfoContainer}>
        <div className={s.ribbonsGroupOnProductInfo}>
          {ribbon && (
            <ConditionalRender by="shouldShowRibbonOnProductInfo" className={s.ribbonWrapper}>
              <Ribbon text={ribbon} dataHook={RibbonDataHook.Primary} />
            </ConditionalRender>
          )}
          {additionalRibbons.map((additionalRibbon, i) => (
            <ConditionalRender key={i} by="shouldShowAdditionalRibbonsOnProductInfo" className={s.ribbonWrapper}>
              <Ribbon text={additionalRibbon} dataHook={RibbonDataHook.Additional} />
            </ConditionalRender>
          ))}
        </div>
      </ConditionalRender>
    );
  }

  return (
    ribbon && (
      <ConditionalRender by="shouldShowRibbonOnProductInfo" dataHook={ProductRibbonsDataHook.OnProductInfoContainer}>
        <div className={s.ribbonsGroupOnProductInfo}>
          <Ribbon text={ribbon} dataHook={RibbonDataHook.Primary} />
        </div>
      </ConditionalRender>
    )
  );
};
